import AppendInput from '../../../../../component/form/AppendInput';
import InputField from '../../../../../component/form/FormInput';
import { getRoundedOff, getRoundedOffAmount } from '../../../components/TaxesCalculation';

const InvoiceFooter = ({
	additionDiscountAndTax,
	setAdditionDiscountAndTax,
	totalAmount,
	totalDiscountAmount,
	totalTaxesAmount,
	invoiceTable,
	calculateAmount,
	type = 'invoice',
}) => {
	const calculateQuantity = () => {
		return invoiceTable?.reduce((sum, item) => Number(sum) + Number(item.quantity), 0);
	};

	return (
		<div
			style={{
				position: 'fixed',
				bottom: 0,
				width: '100%',
				// backgroundColor: '#fff',
				zIndex: 10,
			}}
		>
			{/* Summary Header */}
			<div
				className="max-w-1297"
				style={{
					borderBottom: '1px solid #C3CBDC',
					padding: '0rem 2rem 0',
				}}
			>
				<div
					className="d-flex align-items-center justify-content-between"
					style={{
						height: '36px',
						padding: '0 2rem',
						fontSize: '14px',
						backgroundColor: '#F6F6F9',
					}}
				>
					<div style={{ fontWeight: 400, color: '#555B67' }}>
						Total Items: <span style={{ fontWeight: 700 }}>{invoiceTable.length}</span>
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							fontWeight: 600,
							justifyContent: 'end',
						}}
					>
						{type === 'invoice' && (
							<div style={{ width: '100px', textAlign: 'left' }}>{calculateQuantity()}</div>
						)}
						<div
							style={{
								width: type === 'invoice' && '100px',
								textAlign: type === 'invoice' ? 'left' : 'right',
								marginRight: '60px',
							}}
						>
							{type === 'invoice'
								? calculateAmount().toFixed(2)
								: `Gross Total (excl. taxes) : ₹${calculateAmount().toFixed(2)}`}
						</div>
					</div>
				</div>
			</div>

			{/* Fixed Footer */}
			<div
				style={{
					borderTop: '1px solid #C3CBDC',
					backgroundColor: '#DADDEC',
					boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
					width: '100%',
				}}
			>
				<div
					className="max-w-1297 d-flex justify-content-between"
					style={{
						alignItems: 'flex-start',
						padding: '1rem 2rem',
						flexWrap: 'wrap',
						rowGap: '1rem',
					}}
				>
					{/* Input Fields */}
					<div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
						{/* Discount */}
						<div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
								<span style={{ margin: 0, whiteSpace: 'nowrap' }}>Discount</span>
								<AppendInput
									label=""
									placeholder="0"
									appendLabel="%"
									type="text"
									autoComplete="off"
									className="custom-append-text"
									value={additionDiscountAndTax?.discount}
									onChange={(valueData) => {
										let value = valueData?.replace(/[^0-9.]/g, '');
										const decimalCount = (value.match(/\./g) || []).length;
										if (decimalCount > 1) {
											value = +value?.slice(0, value.lastIndexOf('.'));
										}
										setAdditionDiscountAndTax((prev) => ({
											...prev,
											discount: value,
										}));
									}}
								/>
							</div>
							<p style={{ margin: 0 }}>Discount: ₹{totalDiscountAmount().toFixed(2)}/-</p>
						</div>

						{/* Adjustment */}
						<div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
								<p style={{ margin: 0, whiteSpace: 'nowrap' }}>Adjustment</p>
								<InputField
									value={additionDiscountAndTax.adj}
									type="text"
									autoComplete="off"
									onChange={(valueData) => {
										let value = valueData?.replace(/[^0-9.]/g, '');
										setAdditionDiscountAndTax((prev) => ({ ...prev, adj: value }));
									}}
									placeholder="0.00"
								/>
							</div>
							<p style={{ margin: 0 }}>Adjustments: ₹{additionDiscountAndTax.adj ?? 0.0}/-</p>
						</div>

						{/* Round Off */}
						<div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
								<p style={{ margin: 0, whiteSpace: 'nowrap' }}>Round Off</p>
								<InputField
									value={getRoundedOff(Number(totalAmount()).toFixed(2))}
									type="number"
									autoComplete="off"
									disabled={true}
									onChange={(value) =>
										setAdditionDiscountAndTax((prev) => ({ ...prev, round_off: value }))
									}
									placeholder="0.00"
								/>
							</div>
							<p style={{ margin: 0 }}>Taxes: ₹{totalTaxesAmount().toFixed(2)}/-</p>
						</div>
					</div>

					{/* Total Bill */}
					<div
						style={{ fontWeight: 600, fontSize: '16px', marginTop: '10px', marginRight: '75px' }}
					>
						<p style={{ margin: 0 }}>
							Bill Total: ₹{getRoundedOffAmount(Number(totalAmount()).toFixed(2))}/-
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InvoiceFooter;
